// Roteador puro pras actions emitidas pelos nodes da sidebar.
// Extraído do Sidebar.vue pra ser testável sem montar o componente
// inteiro (1100+ LOC com store/router/vuex/i18n). Recebe as
// dependências por injeção pra facilitar mock no spec.
//
// Cada handler recebe `payload = { action, value? }` (o que o
// SidebarTreeNode emitiu) e o conjunto de utilidades { router, emitter,
// accountScopedRoute, busEvents }.
//
// Pra adicionar uma nova action:
//   1) Sidebar.vue (menuItems): inclui { action: 'minha-action', ... }
//   2) Aqui: adiciona case no switch (ou map de handlers)
//   3) Caller (ChatList/etc): emitter.on do busEvent correspondente

export function createSidebarActionHandler({
  router,
  emitter,
  accountScopedRoute,
  busEvents,
}) {
  return async function handleSidebarAction({ payload } = {}) {
    if (!payload?.action) return;

    switch (payload.action) {
      case 'new-folder':
        await router.push(accountScopedRoute('home'));
        emitter.emit(busEvents.SIDEBAR_OPEN_FOLDER_FILTER);
        break;

      case 'edit-folder':
        await router.push(
          accountScopedRoute('folder_conversations', { id: payload.value })
        );
        emitter.emit(busEvents.SIDEBAR_OPEN_FOLDER_FILTER);
        break;

      case 'new-agent':
        await router.push(accountScopedRoute('agent_list'));
        emitter.emit(busEvents.SIDEBAR_OPEN_AGENT_NEW);
        break;

      case 'new-label':
        await router.push(accountScopedRoute('labels_list'));
        emitter.emit(busEvents.SIDEBAR_OPEN_LABEL_NEW);
        break;

      case 'new-attribute':
        await router.push(accountScopedRoute('attributes_list'));
        emitter.emit(busEvents.SIDEBAR_OPEN_ATTRIBUTE_NEW);
        break;

      case 'new-automation':
        // Automação virou página própria — navega direto, sem emit.
        await router.push(accountScopedRoute('automation_new'));
        break;

      case 'new-agent-bot':
        await router.push(accountScopedRoute('agent_bots'));
        emitter.emit(busEvents.SIDEBAR_OPEN_AGENT_BOT_NEW);
        break;

      case 'new-canned':
        await router.push(accountScopedRoute('canned_list'));
        emitter.emit(busEvents.SIDEBAR_OPEN_CANNED_NEW);
        break;

      case 'new-custom-role':
        await router.push(accountScopedRoute('custom_roles_list'));
        emitter.emit(busEvents.SIDEBAR_OPEN_CUSTOM_ROLE_NEW);
        break;

      case 'new-sla':
        await router.push(accountScopedRoute('sla_list'));
        emitter.emit(busEvents.SIDEBAR_OPEN_SLA_NEW);
        break;

      case 'new-contact':
        await router.push(accountScopedRoute('contacts_dashboard_index'));
        emitter.emit(busEvents.SIDEBAR_OPEN_CONTACT_NEW);
        break;

      default:
        // Action desconhecida — no-op. Sem warn pra evitar ruído em
        // actions custom que os consumers possam adicionar no futuro.
        break;
    }
  };
}
